import { Section, Text, Heading } from '@react-email/components';

// const CheckmarkIcon = () => (
//     <Img
//         width="16"
//         height="12"
//         alt="Checkmark"
//         src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zY3N2Ij48cGF0aCBkPSJNNS41MTAwOSAxMS43NjQzTDAuNzE2MDE0IDYuNTM0NDJDMC40Mjc5OTUgNi4yMjAyMSAwLjQyNzk5NSA1LjcxMDc3IDAuNzE2MDE0IDUuMzk2NTRMMS43NTkwNCA0LjI1ODY1QzIuMDQ3MDYgMy45NDQ0MiAyLjUxNDA4IDMuOTQ0NDIgMi44MDIxIDQuMjU4NjVMNi4wMzE2MiA3Ljc4MTc0TDEyLjk0ODkgMC4yMzU2NTJDMTMuMjM2OSAtMC4wNzg1NTA3IDEzLjcwMzkgLTAuMDc4NTUwNyAxMy45OTE5IDAuMjM1NjUyTDE1LjAzNSAxLjM3MzUzQzE1LjMyMyAxLjY4Nzc0IDE1LjMyMyAyLjE5NzE4IDE1LjAzNSAyLjUxMTQxTDYuNTUzMTUgMTEuNzY0NEM2LjI2NTEgMTIuMDc4NiA1Ljc5ODExIDEyLjA3ODYgNS41MTAwOSAxMS43NjQzWiINCiAgICAgICAgICAgIGZpbGw9IiM5NUNGRDMiDQogICAgICAgIC8+DQogICAgPC9zdmc+"
//     />
// );

const CheckmarkIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
        <path d="M5.51009 11.7643L0.716014 6.53442C0.427995 6.22021 0.427995 5.71077 0.716014 5.39654L1.75904 4.25865C2.04706 3.94442 2.51408 3.94442 2.8021 4.25865L6.03162 7.78174L12.9489 0.235652C13.2369 -0.0785507 13.7039 -0.0785507 13.9919 0.235652L15.035 1.37353C15.323 1.68774 15.323 2.19718 15.035 2.51141L6.55315 11.7644C6.2651 12.0786 5.79811 12.0786 5.51009 11.7643Z" fill="#95CFD3" />
    </svg>);

const NextSteps = ({ heading, subHeading, stepsList }) => {
    return (

        <Section style={{
            backgroundColor: '#F5F1ED',
            padding: '24px 27px',
            borderRadius: '8px',
            marginBottom: '0',
        }}>
            <Heading as="h3" style={{color:'#3E3E4A'}}>{heading}</Heading>
            {subHeading && (
                <Text style={{ margin: '0',color: '#3E3E4A' }}>{subHeading}</Text>
            )}

            <ul style={{ marginTop: '20px', listStyle: 'none', padding:'0' }}>
                {stepsList.map((step, index) => (
                    <li key={index} style={{ color: '#3E3E4A', fontSize: '14px', display: 'flex', alignItems: 'center' }}>
                        {/* <CheckmarkIcon /> */}
                        <span style={{ marginLeft: '8px' }}>{step}</span>
                    </li>
                ))}
            </ul>

        </Section>
    );
};

export default NextSteps;
